import { ACTION_TYPES } from '../../actions/siderActions';

export const INITIAL_STATE = {
  collapsed: true,
};

const SiderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_COLLAPSED:
      return {
        ...state,
        collapsed: action.collapsed,
      };

    default:
      return state;
  }
};

export default SiderReducer;
